// Cache of product data (variant prices) keyed by product URL path.
var cardSwatchProductCache = {};

function cardSwatchGetProduct(productPath) {
  if (!cardSwatchProductCache[productPath]) {
    cardSwatchProductCache[productPath] = fetch(productPath + '.js')
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }
  return cardSwatchProductCache[productPath];
}

function cardSwatchFormat(cents) {
  return '$' + (cents / 100).toFixed(2) + ' USD';
}

function cardSwatchPriceEls(swatch) {
  var card = swatch.closest('.card-wrapper');
  if (!card) return [];
  return card.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale');
}

function cardSwatchSetPrice(swatch) {
  var url = swatch.dataset.variantUrl;
  if (!url) return;
  var parts = url.split('?variant=');
  var productPath = parts[0];
  var variantId = parseInt(parts[1], 10);
  if (!variantId) return;
  swatch.dataset.hoverToken = String(Date.now());
  var token = swatch.dataset.hoverToken;
  cardSwatchGetProduct(productPath).then(function (product) {
    if (!product || swatch.dataset.hoverToken !== token) return;
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === variantId) { variant = product.variants[i]; break; }
    }
    if (!variant) return;
    cardSwatchPriceEls(swatch).forEach(function (el) {
      if (el.dataset.originalPrice === undefined) {
        el.dataset.originalPrice = el.innerHTML;
      }
      el.textContent = cardSwatchFormat(variant.price);
    });
  });
}

document.addEventListener('mouseover', function (e) {
  var swatch = e.target.closest('.card__color-swatch');
  if (!swatch) return;
  var img = document.getElementById(swatch.dataset.targetImg);
  if (img && swatch.dataset.swapSrc) {
    if (img.dataset.originalSrcset === undefined) {
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = swatch.dataset.swapSrc;
  }
  cardSwatchSetPrice(swatch);
});

// Only reset the image and price when the cursor leaves the whole swatch row,
// not when moving between individual swatches inside it.
document.addEventListener('mouseout', function (e) {
  var container = e.target.closest('.card__color-swatches');
  if (!container) return;
  if (container.contains(e.relatedTarget)) return;

  var firstSwatch = container.querySelector('.card__color-swatch');
  if (!firstSwatch) return;
  // Invalidate any in-flight price lookups.
  container.querySelectorAll('.card__color-swatch').forEach(function (s) {
    s.dataset.hoverToken = '';
  });
  cardSwatchPriceEls(firstSwatch).forEach(function (el) {
    if (el.dataset.originalPrice !== undefined) {
      el.innerHTML = el.dataset.originalPrice;
    }
  });
  var img = document.getElementById(firstSwatch.dataset.targetImg);
  if (img && img.dataset.originalSrc) {
    img.src = img.dataset.originalSrc;
    if (img.dataset.originalSrcset) {
      img.setAttribute('srcset', img.dataset.originalSrcset);
    }
  }
});

document.addEventListener('click', function (e) {
  var swatch = e.target.closest('.card__color-swatch');
  if (!swatch) return;
  if (swatch.dataset.variantUrl) {
    window.location.href = swatch.dataset.variantUrl;
  }
});
